<script setup lang="ts">
import { computed, ref } from 'vue';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';

interface Props {
  titleUrl?: string;
  titleUrlFr?: string;
  canEdit: boolean;
  link?: string;
  linkFr?: string;
  typeLink?: string;
  typeLinkFr?: string;
  itemUrl?: string;
  itemUrlFr?: string;
}

const props = defineProps<Props>();

const emits = defineEmits<{
  'update:link': [value: any];
  'update:linkFr': [value: any];
  handleSubmit: [value: string];
}>();
const inputType = ref('');

const linkData = computed({
  get() {
    return props.link;
  },
  set(value) {
    emits('update:link', value);
  }
});

const linkDataFr = computed({
  get() {
    return props.linkFr;
  },
  set(value) {
    emits('update:linkFr', value);
  }
});

const onChange = (type: string) => {
  inputType.value = type;
};

const handleSubmit = async (type: string) => {
  emits('handleSubmit', type);
};
</script>

<template>
  <Splitter>
    <SplitterPanel class="p-5">
      <h5>{{ props.titleUrl }}</h5>
      <div class="flex flex-col">
        <InputText :disabled="!canEdit" class="mb-1" maxlength="500" v-model="linkData" :autoResize="true" rows="5" cols="30" :placeholder="$t('Link')" @keydown="onChange(typeLink)" :defaultValue="itemUrl" />
      </div>
      <Button :disabled="!(canEdit && inputType === typeLink)" :label="$t('promos.save')" icon="pi pi-check" class="cus-btn" @click="handleSubmit(typeLink)" />
    </SplitterPanel>
    <SplitterPanel class="p-5" v-if="props.titleUrlFr">
      <h5>{{ props.titleUrlFr }}</h5>
      <div class="flex flex-col">
        <InputText :disabled="!canEdit" class="mb-1" maxlength="500" v-model="linkDataFr" :autoResize="true" rows="5" cols="30" :placeholder="$t('Link')" @keydown="onChange(typeLinkFr)" :defaultValue="itemUrlFr" />
      </div>
      <Button :disabled="!(canEdit && inputType === typeLinkFr)" :label="$t('promos.save')" icon="pi pi-check" class="cus-btn" @click="handleSubmit(typeLinkFr)" />
    </SplitterPanel>
  </Splitter>
</template>
